import Vue from "vue";
import Router from "vue-router";
import Real from "../view/real/real.vue";
import User from "../view/user/user";
import Index from "../view/index";
import RealDubbing from "../view/real/real_dubbing";
import AboutUs from "../view/aboutUs/aboutUs";
import UserCon from "../view/user/user_con";
import UserReal from "../view/user/user_real";
import UserWorks from "../view/user/user_works";
import UserBill from "../view/user/user_bill";
import VipHub from "../view/recharge/viphub";
import Gold from "../view/recharge/gold";
import Make from "../view/dubbing/make";
import Demo from "../view/dubbing/demo"
import Tools from "../view/tools/tools"
import DownApp from "../view/aboutUs/downapp"
import StringPack from "../view/recharge/string_pack";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "Index",
      component: Index,
      children: [
        {
          path: "/",
          component: UserCon
        },
      ]
    },
    {
      path: "/index",
      name: "Index",
      component: Index
    },
    {
      path: "/downapp",
      name: "DownApp",
      component: DownApp
    },
    {
      path: "/viphub",
      name: "VipHub",
      component: VipHub
    },
    {
      path: "/gold",
      name: "Gold",
      component: Gold
    },
    {
      path: "/stringpack",
      name: "StringPack",
      component: StringPack
    },
    {
      path: "/make",
      name: "Make",
      component: Make
    },
    {
      path: "/demo",
      name: "Demo",
      component: Demo
    },
    {
      path: "/user",
      name: "User",
      component: User,
      children: [
        {
          path: "/",
          component: UserCon
        },
        {
          path: "userreal",
          component: UserReal
        },
        {
          path: "userworks",
          component: UserWorks
        },
        {
          path: "userbill",
          component: UserBill
        }
      ]
    },
    {
      path: "/real",
      name: "real",
      component: Real
    },
    {
        path: '/real_dubbing',
        name: 'RealDubbing',
        component: RealDubbing
    },
    {
        path: '/aboutUs',
        name: 'AboutUs',
        component: AboutUs
    },
    {
      path: '/tools',
      name: 'Tools',
      component: Tools
  }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js